import ui from "./ui";
import cart from "./cart";
import pdp from "./pdp";
import favorites from "./favorites";
import quote from "./quote";

export default { ui, cart, pdp, favorites, quote };
